export default {
    isGridOpen: state => state.gridIsOpen,
    isFormOpen: state => state.formIsOpen,
    isAdditionalTableOpen: state => state.additionalTableIsOpen,

    getDataTableOptions: state => state.dataTableOptions,
    getActions: state => state.actions,
    getRowActions: state => state.rowActions,
    getFormActions: state => state.formActions,
    getHeaderFields: state => state.headerFields,
}
